import axios from 'axios';
import {
  ACCESS_TOKEN,
  config,
} from '../config/Config';

// -- Axios

const instance = axios.create({
  baseURL: config.url.API_BASE_URL,
});

export function saveOrderDataBff(orderRequest) {
  return instance.post("/palaniGounderJewels/order/placeOrder", orderRequest,{
    headers: {
      "Content-type": "application/json",
      Authorization: localStorage.getItem(ACCESS_TOKEN)
        ? "Bearer " + localStorage.getItem(ACCESS_TOKEN)
        : null,
    },
    
  });
  
}

export function saveInvoiceData(paymentInvoiceData) {
  return instance.post("/palaniGounderJewels/order/updateInvoiceData",paymentInvoiceData,{
    headers: {
      "Content-type": "application/json",
      Authorization: localStorage.getItem(ACCESS_TOKEN)
        ? "Bearer " + localStorage.getItem(ACCESS_TOKEN)
        : null,
    },
    
  });
  
}
export function updateInvoicePaymentStatus(email, invoiceNumber, newPaymentStatus,amount,transactionId,serializableProduct) {
  const paymentStatusData = {
    email: email,
    invoiceNumber: invoiceNumber,
    paymentStatus: newPaymentStatus,
    amount:amount,
    transactionId:transactionId,
    order:serializableProduct
  };

  return instance.put("/palaniGounderJewels/order/updateInvoicePaymentStatus", paymentStatusData, {
    headers: {
      "Content-type": "application/json",
      Authorization: localStorage.getItem(ACCESS_TOKEN)
        ? "Bearer " + localStorage.getItem(ACCESS_TOKEN)
        : null,
    },
  });
}


export function saveGoldLoanDataBff(loanRequest) {
  return instance.put("/palaniGounderJewels/common/updateAppliedFor", loanRequest,{
    headers: {
      "Content-type": "application/json",
      Authorization: localStorage.getItem(ACCESS_TOKEN)
        ? "Bearer " + localStorage.getItem(ACCESS_TOKEN)
        : null,
    },
    
  });
  
}
export function retrieveGvgOrder(email) {
  // alert("userName!!!"+clientUserName)
  return instance.get(`/palaniGounderJewels/order/orders/${email}`, {
    headers: {
      'Content-type': 'application/json',
      Authorization: localStorage.getItem(ACCESS_TOKEN)
        ? `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`
        : null,
    },
  });
}
export function retrieveInvoiceList(email) {
  // alert("userName!!!"+clientUserName)
  return instance.get(`/palaniGounderJewels/order/invoiceList/${email}`, {
    headers: {
      'Content-type': 'application/json',
      Authorization: localStorage.getItem(ACCESS_TOKEN)
        ? `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`
        : null,
    },
  });
}
export function retrieveGvgPlan(email) {
  // alert("userName!!!"+clientUserName)
  return instance.get(`/palaniGounderJewels/plan/plan/${email}`, {
    headers: {
      'Content-type': 'application/json',
      Authorization: localStorage.getItem(ACCESS_TOKEN)
        ? `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`
        : null,
    },
  });
}
export function savePlanDataBff(orderRequest) {
  return instance.post("palaniGounderJewels/plan/choosePlan", orderRequest,{
    headers: {
      "Content-type": "application/json",
      Authorization: localStorage.getItem(ACCESS_TOKEN)
        ? "Bearer " + localStorage.getItem(ACCESS_TOKEN)
        : null,
    },
    
  });
  
}
export function saveWishlistDataBff(orderRequest) {
  return instance.post("palaniGounderJewels/plan/choosePlan", orderRequest,{
    headers: {
      "Content-type": "application/json",
      Authorization: localStorage.getItem(ACCESS_TOKEN)
        ? "Bearer " + localStorage.getItem(ACCESS_TOKEN)
        : null,
    },
    
  });
  
}
export function createProduct(productRequest) {
  return instance.post("palaniGounderJewels/secure/admin/addToProduct", productRequest,{
    headers: {
      "Content-type": "application/json",
      Authorization: localStorage.getItem(ACCESS_TOKEN)
        ? "Bearer " + localStorage.getItem(ACCESS_TOKEN)
        : null,
    },
    
  });
  
}
export function saveGoldLoanData(loanRequest) {
  return instance.post("palaniGounderJewels/plan/choosePlan", loanRequest,{
    headers: {
      "Content-type": "application/json",
      Authorization: localStorage.getItem(ACCESS_TOKEN)
        ? "Bearer " + localStorage.getItem(ACCESS_TOKEN)
        : null,
    },
    
  });
  
}
export function retrieveUserData() {
  return instance.get("palaniGounderJewels/order/dashboard/pupil/order", {
    headers: {
      "Content-type": "application/json",
      Authorization: localStorage.getItem(ACCESS_TOKEN)
        ? "Bearer " + localStorage.getItem(ACCESS_TOKEN)
        : null,
    },
  });
}

export function getGvgOrder() {
 
  return instance.get(
    `/palaniGounderJewels/secure/admin/dashboard/users/order`,
    {
      headers: {
        'Content-type': 'application/json',
        Authorization: localStorage.getItem(ACCESS_TOKEN) ? `Bearer ${localStorage.getItem(ACCESS_TOKEN)}` : null,
      },
    },
  );
}


export function getPGJOrgData(email) {
 
  return instance.get(
    `/palaniGounderJewels/secure/admin/getOrgDataForInventoryProduct/${email}`,
    {
      headers: {
        'Content-type': 'application/json',
        Authorization: localStorage.getItem(ACCESS_TOKEN) ? `Bearer ${localStorage.getItem(ACCESS_TOKEN)}` : null,
      },
    },
  );
}
export function getGvgData() {
 
  return instance.get(
    `/palaniGounderJewels/secure/admin/dashboard/users/palaniGounderJewels`,
    {
      headers: {
        'Content-type': 'application/json',
        Authorization: localStorage.getItem(ACCESS_TOKEN) ? `Bearer ${localStorage.getItem(ACCESS_TOKEN)}` : null,
      },
    },
  );
}
export function getGvgPlan() {
 
  return instance.get(
    `/palaniGounderJewels/secure/admin/dashboard/users/plan`,
    {
      headers: {
        'Content-type': 'application/json',
        Authorization: localStorage.getItem(ACCESS_TOKEN) ? `Bearer ${localStorage.getItem(ACCESS_TOKEN)}` : null,
      },
    },
  );
}
export function getGvgOrderPlan() {
 
  return instance.get(
    `/palaniGounderJewels/secure/admin/dashboard/users/orderAndPlan`,
    {
      headers: {
        'Content-type': 'application/json',
        Authorization: localStorage.getItem(ACCESS_TOKEN) ? `Bearer ${localStorage.getItem(ACCESS_TOKEN)}` : null,
      },
    },
  );
}